import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';

import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { VoiceRecorderService } from '../../../services/voice-recorder.service';

@Component({
  selector: 'app-voice-recorder',
  templateUrl: './voice-recorder.component.html',
  styleUrls: ['./voice-recorder.component.css']
})
export class VoiceRecorderComponent implements OnInit, AfterViewInit {

  @ViewChild('canvas') canvasRef!: ElementRef<HTMLCanvasElement>;
  @Output('descartar') eventDescartar = new EventEmitter<boolean>();
  @Output('blobAudio') eventBlobEnviar = new EventEmitter<Blob>();
  audioUrl: SafeUrl | null = null;
  isRecording = false;
  isPaused = false;
  elapsedTime = 0;
  private timer: any;
  constructor(private recorder: VoiceRecorderService, private sanitizer: DomSanitizer) {}

  ngAfterViewInit(): void {
    this.start();
  }

  ngOnInit(): void {
  }

  async start() {
    await this.recorder.startRecording(this.canvasRef);
    this.isRecording = true;
    this.isPaused = false;
    this.elapsedTime = 0;
    this.startTimer();
  }

  pause() {
    this.recorder.pauseRecording();
    this.isPaused = true;
  }

  resume() {
    this.recorder.resumeRecording();
    this.isPaused = false;
  }

  async stop() {
    const blob = await this.recorder.stopRecording();
    this.audioUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
    this.isRecording = false;
    this.isPaused = false;
    this.stopTimer();
    this.eventBlobEnviar.emit(blob);
  }

  togglePauseResume() {
    if (this.isPaused) {
      this.recorder.resumeRecording();
      this.isPaused = false;
      this.startTimer();
    } else {
      this.recorder.pauseRecording();
      this.isPaused = true;
      this.stopTimer();
    }
  }

  deleteRecording() {
    this.recorder.stopRecording();
    this.audioUrl = null;
    this.elapsedTime = 0;
    this.isRecording = false;
    this.isPaused = false;
    this.stopTimer();
    this.eventDescartar.emit();
  }

  limiteTime = 60 * 1000;

  private startTimer() {
    this.stopTimer();
    this.timer = setInterval(() => {
      this.elapsedTime += 1000;
      if(this.elapsedTime >= this.limiteTime){
        this.recorder.pauseRecording();
        this.stopTimer();
        this.isRecording = false;
      }
    }, 1000);
  }

  private stopTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  ngOnDestroy() {
    this.stopTimer();
  }


}
